import { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const InsuranceProducts = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="insurance-page">
      <SEO
        title="Insurance Products"
        description="Comprehensive insurance solutions for financial protection and risk management. Term life, health, family, motor, and asset coverage plans."
      />

      <section className="service-banner">
        <img
          src="/images/banners/insurance-banner.avif"
          alt="Insurance Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/insurance-mobile-banner.avif"
          alt="Insurance Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Insurance <span>Products</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              A comprehensive financial strategy is incomplete without adequate
              risk protection. Insurance serves as the foundation of financial
              security by safeguarding income, assets, health, and long-term
              wealth against unforeseen events.
            </p>
            <p>
              Our Insurance Solutions platform provides access to a wide range
              of life and general insurance products designed to protect
              individuals, families, and businesses through structured risk
              planning and coverage evaluation.
            </p>
            <p>
              We focus on aligning coverage adequacy with financial goals,
              ensuring that protection planning complements wealth creation
              strategies.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/insurance-offer.avif"
              alt="Insurance Solutions Offer"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt="Background Decoration"
          className="offer-bg"
        />
      </section>

      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Protect what matters most with bespoke insurance solutions.
              Thoughtfully designed to provide financial security for every
              stage of life.
            </p>
            <img
              src="/images/services/insurance-highlight.png"
              alt="Insurance Highlights"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Term &amp; life insurance solutions</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Health &amp; family protection plans</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Motor &amp; asset coverage</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Coverage adequacy assessment</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Policy comparison &amp; servicing support</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Insurance is the subject matter of solicitation.
            Please read policy terms, conditions, and benefit illustrations
            carefully before purchasing.
          </p>
        </div>
      </section>

      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="App Download Preview"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default InsuranceProducts;
